function toggleMenu() {
  document.querySelector(".mobile-menu").classList.toggle("open");
}

function closeMenu() {
  document.querySelector(".mobile-menu").classList.remove("open");

  // Close all submenu items by removing the "active" class
  var submenuItems = document.querySelectorAll(".has-submenu.active");
  submenuItems.forEach(function (submenuItem) {
    submenuItem.classList.remove("active");
  });
}

document.addEventListener("DOMContentLoaded", function () {
  var nestedItems = document.querySelectorAll(".has-submenu > a");
  nestedItems.forEach(function (item) {
    item.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      this.parentElement.classList.toggle("active");
    });
  });
});

// Close the submenu when a link with "data-drawers-back" is clicked
var backLinks = document.querySelectorAll("[data-drawers-back]");
backLinks.forEach(function (backLink) {
  backLink.addEventListener("click", function (event) {
    event.preventDefault(); //
    event.stopPropagation();
    var submenu = this.closest(".submenu");
    if (submenu) {
      submenu.parentElement.classList.remove("active");
    }
  });
});
